export default {
  name: "productItem",
  props: {
    product: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  components: {},
  mounted() {},
  data() {
    return {}
  },
  methods: {
    goToDetails() {
      this.$router.push("/product/" + this.product._id)
    },
    buyNow() {
      var itemForBasket = {
        product: this.product,
        quantity: 1,
      }

      this.$store.commit("addOrEditItem", itemForBasket)
      this.$router.push("/checkout")
    },
  },
  computed: {},
  beforeCreate() {},
  created() {},
}



// WEBPACK FOOTER //
// ./src/components/Marketplace/MarketBoard/ProductItem/ProductItem.component.js